import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ChevronRight } from 'lucide-react';
export const PrivacyPolicyPage = () => {
  const lastUpdated = 'September 15, 2023';
  return <div className="min-h-screen flex flex-col" data-id="element-677">
      <Header data-id="element-678" />
      <main className="flex-grow pt-20" data-id="element-679">
        {/* Hero Banner */}
        <div className="bg-[#0a2351] text-white py-16" data-id="element-680">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-681">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-682">
              Privacy Policy
            </h1>
            <p className="text-xl text-gray-200 max-w-2xl" data-id="element-683">
              How we collect, use, and protect your information
            </p>
            <nav className="flex mt-6" aria-label="Breadcrumb" data-id="element-684">
              <ol className="inline-flex items-center space-x-1 md:space-x-3" data-id="element-685">
                <li className="inline-flex items-center" data-id="element-686">
                  <a href="/" className="text-gray-300 hover:text-white" data-id="element-687">
                    Home
                  </a>
                </li>
                <li data-id="element-688">
                  <div className="flex items-center" data-id="element-689">
                    <ChevronRight className="w-4 h-4 text-gray-300" data-id="element-690" />
                    <span className="ml-1 text-white md:ml-2" data-id="element-691">
                      Privacy Policy
                    </span>
                  </div>
                </li>
              </ol>
            </nav>
          </div>
        </div>
        {/* Privacy Policy Content */}
        <section className="py-12 bg-white" data-id="element-692">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-693">
            <div className="max-w-4xl mx-auto" data-id="element-694">
              <div className="bg-white rounded-lg shadow-sm p-8 mb-8" data-id="element-695">
                <div className="mb-8 text-sm text-gray-500" data-id="element-696">
                  Last Updated: {lastUpdated}
                </div>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-697">
                  Introduction
                </h2>
                <p className="mb-6 text-gray-700" data-id="element-698">
                  At Sapis Capital Group ("Sapis," "we," "us," or "our"), we
                  respect your privacy and are committed to protecting your
                  personal information. This Privacy Policy explains how we
                  collect, use, disclose, and safeguard your information when
                  you visit our website or use our services.
                </p>
                <p className="mb-8 text-gray-700" data-id="element-699">
                  Please read this Privacy Policy carefully. If you do not agree
                  with the terms of this Privacy Policy, please do not access
                  our website or use our services.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-700">
                  Information We Collect
                </h2>
                <h3 className="text-xl font-semibold mb-4 text-[#0a2351]" data-id="element-701">
                  Personal Information
                </h3>
                <p className="mb-4 text-gray-700" data-id="element-702">
                  We may collect personal information that you voluntarily
                  provide to us when you:
                </p>
                <ul className="list-disc pl-8 mb-6 text-gray-700" data-id="element-703">
                  <li className="mb-2" data-id="element-704">Register for an account</li>
                  <li className="mb-2" data-id="element-705">
                    Express interest in obtaining information about us or our
                    products and services
                  </li>
                  <li className="mb-2" data-id="element-706">
                    Participate in activities on our website
                  </li>
                  <li className="mb-2" data-id="element-707">Contact us</li>
                </ul>
                <p className="mb-6 text-gray-700" data-id="element-708">
                  This information may include:
                </p>
                <ul className="list-disc pl-8 mb-8 text-gray-700" data-id="element-709">
                  <li className="mb-2" data-id="element-710">
                    Name, email address, and contact information
                  </li>
                  <li className="mb-2" data-id="element-711">Job title and company name</li>
                  <li className="mb-2" data-id="element-712">
                    Financial information necessary for investment activities
                  </li>
                  <li className="mb-2" data-id="element-713">
                    Any other information you choose to provide
                  </li>
                </ul>
                <h3 className="text-xl font-semibold mb-4 text-[#0a2351]" data-id="element-714">
                  Automatically Collected Information
                </h3>
                <p className="mb-4 text-gray-700" data-id="element-715">
                  When you visit our website, we may automatically collect
                  certain information about your device, including:
                </p>
                <ul className="list-disc pl-8 mb-8 text-gray-700" data-id="element-716">
                  <li className="mb-2" data-id="element-717">IP address</li>
                  <li className="mb-2" data-id="element-718">Browser type and version</li>
                  <li className="mb-2" data-id="element-719">Pages visited and time spent</li>
                  <li className="mb-2" data-id="element-720">Referring website</li>
                  <li className="mb-2" data-id="element-721">Operating system</li>
                </ul>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-722">
                  How We Use Your Information
                </h2>
                <p className="mb-4 text-gray-700" data-id="element-723">
                  We may use the information we collect for various purposes,
                  including:
                </p>
                <ul className="list-disc pl-8 mb-8 text-gray-700" data-id="element-724">
                  <li className="mb-2" data-id="element-725">
                    Providing, maintaining, and improving our services
                  </li>
                  <li className="mb-2" data-id="element-726">
                    Processing transactions and sending related information
                  </li>
                  <li className="mb-2" data-id="element-727">
                    Responding to inquiries and providing customer support
                  </li>
                  <li className="mb-2" data-id="element-728">Sending administrative information</li>
                  <li className="mb-2" data-id="element-729">
                    Sending marketing and promotional communications (with your
                    consent)
                  </li>
                  <li className="mb-2" data-id="element-730">
                    Protecting against malicious, deceptive, or illegal activity
                  </li>
                </ul>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-731">
                  Disclosure of Your Information
                </h2>
                <p className="mb-4 text-gray-700" data-id="element-732">
                  We may share your information in the following situations:
                </p>
                <ul className="list-disc pl-8 mb-8 text-gray-700" data-id="element-733">
                  <li className="mb-2" data-id="element-734">
                    With service providers who perform services for us
                  </li>
                  <li className="mb-2" data-id="element-735">To comply with legal obligations</li>
                  <li className="mb-2" data-id="element-736">
                    To protect our rights, privacy, safety, or property
                  </li>
                  <li className="mb-2" data-id="element-737">
                    In connection with a business transaction such as a merger
                    or acquisition
                  </li>
                  <li className="mb-2" data-id="element-738">
                    With your consent or at your direction
                  </li>
                </ul>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-739">
                  Security of Your Information
                </h2>
                <p className="mb-8 text-gray-700" data-id="element-740">
                  We use appropriate technical and organizational measures to
                  protect your personal information. However, no electronic
                  transmission or storage system is 100% secure, and we cannot
                  guarantee the absolute security of your information.
                </p>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-741">
                  Your Privacy Rights
                </h2>
                <p className="mb-4 text-gray-700" data-id="element-742">
                  Depending on your location, you may have certain rights
                  regarding your personal information, such as:
                </p>
                <ul className="list-disc pl-8 mb-8 text-gray-700" data-id="element-743">
                  <li className="mb-2" data-id="element-744">
                    Right to access your personal information
                  </li>
                  <li className="mb-2" data-id="element-745">
                    Right to correct inaccurate information
                  </li>
                  <li className="mb-2" data-id="element-746">
                    Right to request deletion of your information
                  </li>
                  <li className="mb-2" data-id="element-747">
                    Right to restrict processing of your information
                  </li>
                  <li className="mb-2" data-id="element-748">Right to data portability</li>
                  <li className="mb-2" data-id="element-749">Right to object to processing</li>
                </ul>
                <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-750">
                  Contact Us
                </h2>
                <p className="text-gray-700" data-id="element-751">
                  If you have questions or concerns about this Privacy Policy or
                  our practices, please contact us at:
                </p>
                <div className="mt-4 text-gray-700" data-id="element-752">
                  <p data-id="element-753">Sapis Capital Group</p>
                  <p data-id="element-754">123 Finance Street, Suite 500</p>
                  <p data-id="element-755">New York, NY 10001</p>
                  <p data-id="element-756">Email: privacy@sapiscapital.com</p>
                  <p data-id="element-757">Phone: (212) 555-0123</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-758" />
    </div>;
};